import { type DBDiscovery } from "./content.functions";
import { dailySeed } from "./history";
import { HOMEPAGE_HERO_V2 } from "./feature-flags";

export function pickHeroDiscovery(discoveries: DBDiscovery[], heroSlugOverride: string | null): DBDiscovery | null {
  if (!discoveries || discoveries.length === 0) return null;

  const seed = dailySeed(31);
  const withImage = discoveries.filter((d) => !!d.image_url);
  const highQuality = withImage.filter((d) => ((d as any).quality_score ?? 0) >= 85);
  const recentByDate = withImage
    .slice()
    .sort((a, b) => +new Date(b.created_at) - +new Date(a.created_at));

  const merged: DBDiscovery[] = [];
  const seenHero = new Set<string>();
  for (const d of [...highQuality, ...recentByDate]) {
    if (seenHero.has(d.slug)) continue;
    seenHero.add(d.slug);
    merged.push(d);
    if (merged.length >= 40) break;
  }

  const rotated = merged
    .map((d, i) => ({ d, k: (seed ^ ((i + 7) * 2654435761)) >>> 0 }))
    .sort((a, b) => a.k - b.k)
    .map((x) => x.d);

  const override = heroSlugOverride ? discoveries.find((d) => d.slug === heroSlugOverride) : null;
  const ordered = override
    ? [override, ...rotated.filter((d) => d.slug !== override.slug)]
    : rotated;

  return HOMEPAGE_HERO_V2 && ordered.length > 0 ? ordered[0] : (merged[0] || null);
}
